import { useState } from 'react';
import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';
import Button from '../components/Button';
import Field from '../components/Field';
import Callout from '../components/Callout';
import { api } from '../lib/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const submit = async () => {
    setSending(true);
    // The API answers the same way whether or not the address is registered,
    // so this screen must not branch on the result either.
    await api.requestMagicLink(email).catch(() => {});
    setSending(false);
    setSent(true);
  };

  return (
    <AppShell
      action={
        <Link to="/request-access" className="t-meta min-h-tap inline-flex items-center font-semibold text-green-700">
          Request access
        </Link>
      }
    >
      <p className="t-eyebrow text-green-600">Sign in</p>
      <h1 className="t-h1 mt-3 text-ink">We will email you a link</h1>
      <p className="t-body-lg measure mt-4 text-grey-600">
        No password to remember. Enter your email and we will send a link that signs you
        in. It works once and lasts a day.
      </p>

      {sent ? (
        <div className="mt-10 max-w-xl">
          <Callout tone="confirm" title="Check your email">
            If that address has access, a link is on its way. It expires in 24 hours, and
            you can ask for another one any time. Check your spam folder if it is not
            in your inbox in a minute.
          </Callout>
          <p className="t-meta mt-6 text-grey-600">
            Nothing arrived?{' '}
            <button
              type="button"
              onClick={() => setSent(false)}
              className="rounded-sm font-semibold text-green-700 underline decoration-1 underline-offset-4"
            >
              Try a different address
            </button>
            , or{' '}
            <Link to="/request-access" className="rounded-sm font-semibold text-green-700 underline decoration-1 underline-offset-4">
              request access
            </Link>
            .
          </p>
        </div>
      ) : (
        <div className="mt-10 max-w-md">
          <Field
            id="login-email"
            label="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="mt-6">
            <Button block onClick={() => void submit()} disabled={sending || email.trim().length < 3}>
              {sending ? 'Sending…' : 'Email me a link'}
            </Button>
          </div>
        </div>
      )}
    </AppShell>
  );
}
